import {useState, useEffect, useContext, createRef} from "react";
import {mainContext} from 'reducer';
import {createPopper} from "@popperjs/core";
import {t} from "utils/text.js";
import {RANKENUM} from "constants.js";

const NftDropdown = () => {
    const {state} = useContext(mainContext);
    const { nft } = state;

    const [dropdownPopoverShow, setDropdownPopoverShow] = useState(false);
    const imgDropdownRef = createRef();
    const popoverDropdownRef = createRef();
    const openDropdownPopover = () => {
        createPopper(imgDropdownRef.current, popoverDropdownRef.current, {
            placement: "bottom",
        });
        setDropdownPopoverShow(true);
    };
    const closeDropdownPopover = () => {
        setDropdownPopoverShow(false);
    };


    useEffect(() => {
        const t = function () {
            closeDropdownPopover();
        };
        document.addEventListener("click", t);
        return () => {
            document.removeEventListener("click", t);
        };
    }, []);

    return (
        <>
            <img
                className='nft_img'
                src={require('../../assets/img/icon-nft.png').default}
                alt="nft"
                ref={imgDropdownRef} 
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                    dropdownPopoverShow ? closeDropdownPopover() : openDropdownPopover();
                }}
            />

            <div ref={popoverDropdownRef} className={(dropdownPopoverShow ? "block " : "hidden ") + 
                "ff font-bold _box_shadow flex flex-col items-center justify-center bg-white z-50 float-left w-290-px h-300-px rounded shadow-lg mt-20-px"}>
                    <div className="drop_arrow"></div>
                <img
                    className={(nft.tokenId ? 'has_nft_img' : 'no_nft_img')}
                    src={nft.tokenId ? `https://gateway.btfs.io/btfs/QmXpe8tj7wSYxHaY311eYjeB1pXQcMrNzJZEqt6BGMCHiw/${nft.tokenId}.png` : require('../../assets/img/no-nft.png').default}
                    alt="nft"
                />

                {nft.tokenId ?
                    <div className="mt-30-px add-grey-color-100 text-center">
                        <span className="add-color-000">
                            {t(RANKENUM[nft.level] || 'no_rank')} {t('genesis')} NFT #{nft.tokenId}
                        </span>
                        <br />
                        {nft.amount ? 
                            <p className="flex items-center main-color mt-5-px">
                                <img className="gift_img" src={require('../../assets/img/icon-gift.png').default} alt="gift" />
                                <span className="mt-5-px">{t('has_nft')} {nft.amount} $NFT {t('award')} </span>
                            </p> :
                            <p className="flex items-center add-grey-color-200 mt-5-px">
                                <img className="gift_img" src={require('../../assets/img/icon-no-gift.png').default} alt="gift" />
                                <span className="mt-5-px">{t('no_nft')} $NFT {t('award')}</span>
                            </p>
                        }
                    </div> :
                    <p className="mt-30-px add-grey-color-100 text-center">
                        {t('no_mint')}
                    </p>
                }
            </div>

        </>
    );
};

export default NftDropdown;
